<template>
  <div class="p-6">
    <div class="container space-y-6">
      <div class="flex items-center space-x-2">
        <div class="flex flex-col space-y-1">
          <label for="busca" class="text-xs"> Buscar </label>
          <input
            name="busca"
            type="text"
            placeholder="Buscar"
            v-model="search"
            class="bg-ontick-graphite-500 rounded border-none px-2 text-sm shadow"
          />
        </div>
        <div class="flex flex-col space-y-1">
          <label for="colunas" class="text-xs"> Colunas (até 12) </label>
          <input
            name="colunas"
            type="number"
            placeholder="Colunas (até 12)"
            max="12"
            v-model="columns"
            class="bg-ontick-graphite-500 rounded border-none px-2 text-sm shadow"
          />
        </div>
      </div>
      <div class="grid gap-2" :class="columnsClass">
        <button
          v-for="(icon, index) in filteredList"
          :key="icon"
          class="flex flex-col space-y-2 rounded p-2 hover:ring-2"
          @click="copy(icon)"
        >
          <i v-html="$icons[icon]"></i>
          <span class="text-xs">
            {{ `${index + 1}: ${icon}` }}
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      search: "",
      columns: 3,
    };
  },

  computed: {
    iconList() {
      return Object.keys(this.$icons);
    },

    filteredList() {
      return this.search.length
        ? this.iconList.filter((item) =>
            item.toLowerCase().includes(this.search.toLowerCase())
          )
        : this.iconList;
    },

    columnsClass() {
      return `grid-cols-${this.columns}`;
    },
  },

  methods: {
    copy(icon) {
      navigator.clipboard
        .writeText(icon)
        .then(() => {
          this.$swal({
            position: "top-end",
            toast: true,
            icon: "success",
            title: "Copiado",
            showConfirmButton: false,
            showCloseButton: false,
            timer: 1500,
          });
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
};
</script>

<style></style>
